<template>
  <div class="overflow-hidden lg:flex lg:h-screen">
    <div
      v-if="uiStore.mountedSchool"
      class="rounded-b-[50px] lg:flex-1 lg:rounded-b-none"
      :class="textColourClass"
      :style="backgroundStyle"
    >
      <DefaultGrid class="h-full">
        <div class="relative col-span-full h-full text-center">
          <div
            class="flex flex-col items-center justify-center pt-8 pb-10 md:pt-16 md:pb-28 lg:h-full lg:pt-0 lg:pb-52"
          >
            <SchoolLogo :school="uiStore.mountedSchool" />
            <h2
              class="mt-6 text-[15px]/[1.2em] font-medium opacity-50 md:mt-7 md:text-[22px]/[1.3em] lg:mt-10 lg:text-[18px]/[1em]"
              v-text="uiStore.mountedSchool.name"
            />
            <h1
              class="mt-2.5 max-w-sm text-[22px]/[1.2em] font-medium md:mt-7 md:max-w-[440px] md:text-[48px]/[1.1em] md:tracking-[0.48px] lg:mt-8"
            >
              Join the movement<br />
              and say you’ll wait!
            </h1>
          </div>
          <div
            class="absolute inset-x-0 bottom-0 hidden flex-col items-center pb-10 lg:flex"
          >
            <NuxtLink to="/">
              <SvgLogo
                class="h-[72px] w-auto"
                :style="logoStyle"
                :invert="invertLogo"
              />
            </NuxtLink>
          </div>
        </div>
      </DefaultGrid>
    </div>
    <div
      v-else
      class="relative hidden overflow-hidden bg-[#94e4e1] px-10 pt-10 pb-10 lg:flex lg:flex-1 lg:flex-col lg:items-center"
    >
      <img
        src="/images/background-fireworks.svg"
        alt=""
        aria-hidden="true"
        class="pointer-events-none absolute top-1/2 left-1/2 w-[120%] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-50"
      />
      <NuxtLink to="/" class="relative z-10 shrink-0">
        <SvgLogo class="text-grey h-[72px]" />
      </NuxtLink>
      <div
        class="relative z-10 flex min-h-0 w-full flex-1 items-center justify-center py-8"
      >
        <div class="relative aspect-[459/437] max-h-full w-full max-w-[460px]">
          <img
            src="/images/girl-and-boy-laugh.png"
            alt=""
            aria-hidden="true"
            class="absolute top-[9.03%] left-0 w-[76.69%]"
          />
          <img
            src="/images/girls-eating-watermelon.png"
            alt=""
            aria-hidden="true"
            class="absolute top-[44.86%] left-[50.89%] w-[52.5%]"
          />
        </div>
      </div>
      <PledgeSupportersCard
        class="relative z-10 w-full max-w-[640px] shrink-0"
      />
    </div>
    <div class="overflow-y-auto lg:flex-1">
      <div
        v-if="!uiStore.mountedSchool"
        class="relative flex h-[176px] items-center justify-center overflow-hidden bg-[#94e4e1] md:h-[152px] lg:hidden"
      >
        <img
          src="/images/background-fireworks.svg"
          alt=""
          aria-hidden="true"
          class="pointer-events-none absolute top-1/2 left-1/2 w-[135%] max-w-none -translate-x-1/2 -translate-y-1/2 opacity-60"
        />
        <NuxtLink to="/" class="relative z-10">
          <SvgLogo class="text-grey h-16 md:h-[72px]" />
        </NuxtLink>
      </div>
      <slot />
      <div
        v-if="uiStore.mountedSchool"
        class="flex flex-col items-center gap-y-5 pb-10 lg:hidden"
      >
        <NuxtLink to="/">
          <SvgLogo class="text-grey h-14" />
        </NuxtLink>
        <p class="type-label opacity-50">Powered by Wait Mate</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const uiStore = useUIStore()

const backgroundStyle = computed(() => ({
  backgroundColor: uiStore.mountedSchool?.themeColour ?? '',
}))

const textColourClass = getContrastingColour(
  uiStore.mountedSchool?.themeColour ?? '',
  'text-black',
  'text-white',
)

const logoStyle = computed(() => ({
  color: uiStore.mountedSchool?.themeColour ?? '',
}))

const invertLogo = getContrastingColour(
  uiStore.mountedSchool?.themeColour ?? '',
  false,
  true,
)
</script>
